import scriptLoader from 'react-async-script-loader';
import { Elements, injectStripe, StripeProvider } from 'react-stripe-elements';
import { compose, lifecycle, withState } from 'recompact';

const wrapWithElements = BaseComponent => props => {
  const { stripe } = props;

  return (
    <StripeProvider stripe={stripe}>
      <Elements>
        <BaseComponent {...props} />
      </Elements>
    </StripeProvider>
  );
};

export const withStripeElements = compose(
  // TODO: Replace with next/script and uninstall `react-async-script-loader`
  scriptLoader(['https://js.stripe.com/v3/']),
  withState('stripe', 'setStripe', null),
  lifecycle({
    componentDidMount() {
      const { setStripe } = this.props;

      if ((window as any).Stripe) {
        // eslint-disable-next-line new-cap
        setStripe((window as any).Stripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISH_KEY));
      }
    },
    componentDidUpdate() {
      const { stripe, setStripe } = this.props;

      if ((window as any).Stripe && !stripe) {
        // eslint-disable-next-line new-cap
        setStripe((window as any).Stripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISH_KEY));
      }
    },
  }),
  wrapWithElements,
  injectStripe
);
